import React from "react";
import { SiGmail, SiInstagram, SiFacebook, SiAndroid, SiApple, SiYoutube, SiWhatsapp } from "react-icons/si";
import { Link } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import "./Footer.css";

const Footer = () => {
  return (
    <>
      <br />
      <footer>
        <div className="leftside">
          <div className="links_parent">
            <div className="product">
              <a
                href="https://maps.app.goo.gl/b8h2viLQjHXRevEg9"
                target="_blank"
                rel="noopener noreferrer"
                className="footer__link"
                aria-label="Sri Periya Ponnachi Amman Temple"
              >
                ஸ்ரீ பெரிய பொன்னாச்சி அம்மன் கோவில்
              </a>

              <a
                href="https://maps.app.goo.gl/KXiqAxJG5cN1NrG7A"
                target="_blank"
                rel="noopener noreferrer"
                className="footer__link"
                aria-label="Sri Chinna Ponnachi Amman Temple"
              >
                ஸ்ரீ சின்ன பொன்னாச்சி அம்மன் கோவில்
              </a>
              <br />
              <h1>விதரி அத்திபாளையம் கிராமம், அரையநாடு<br /><br />
                அத்திபாளையம் கிராமம், புகளூர் வட்டம், கரூர் மாவட்டம்-639111<br />
              </h1>
            </div>
            <div className="product">
              <h1>முக்கியமான பக்கங்கள்</h1>
              <Link to={"/contactus"}>வருகை</Link>
              <Link to={"/auth/login"}>புகுபதிகை</Link>
              <Link to={"/contactus"}>தொடர்புகொள்ளக</Link>
            </div>
            <div className="policies">
              <h1>கொள்கைகள்</h1>

              <Link to={"/privacy-policy"}>தனியுரிமை கொள்கை</Link>
            </div>
          </div>

          <div className="policies_mobile">
            <Link to={"/privacy-policy"}>தனியுரிமை கொள்கை</Link>
          </div>
        </div>


        <div className="rightside">

          <a
            href="https://play.google.com/store/apps/details?id=com.sriponnachiammantemples.test&pcampaignid=web_share"
            target="_blank"
            rel="noopener noreferrer"
          >
            <SiAndroid color="#3DDC84" size={24} />
          </a>
          <div className="" ></div>
          <a
            href="http://sriponnachiammantemples.in/register"
            target="_blank"
            rel="noopener noreferrer"
          >
            <SiApple color="#ffffff" size={24}/>
          </a>
          <div className="" ></div>
          <a
            href="https://whatsapp.com/channel/0029Vamg0f21dAvzNUTrPf2d"  // Replace with your actual channel link
            target="_blank"
            rel="noopener noreferrer"
            style={{ display: 'inline-block' }}
          >
            <SiWhatsapp color="#25D366" size={24} />
          </a>
          <div className="" ></div>
          <a
            href="https://www.instagram.com/sriponnachiammantemples"
            target="_blank"
            rel="noopener noreferrer"
          >
            <SiInstagram color="#E1306C" size={24}/>
          </a>
          <div className="" ></div>
          <a
            href="https://www.facebook.com/profile.php?id=61578804112994"
            target="_blank"
            rel="noopener noreferrer"
          >
            <SiFacebook color="#1877F2" size={24}/>
          </a>
          <div className="" ></div>
          <a
            href="https://www.youtube.com/@SriPonnachiAmmanTemples"  // Replace with your actual channel link
            target="_blank"
            rel="noopener noreferrer"
            style={{ display: 'inline-block' }}
          >
            <SiYoutube color="#FF0000" size={24} />
          </a>
          <div className="" ></div>
          <Link to={"mailto:sriponnachiammantemples@gmail.com?subject=Enquiry&body=I%20would%20like%20to%20inquire..."}>
            <SiGmail color="#ffffff" size={24} />
          </Link>
        </div>
      </footer>
    </>
  );
};

export default Footer;
